export default {
  "ThirdPartyContents.Title1": "ご自身のデータの提供先の確認状況",
  "ThirdPartyContents.Title2": "設定変更",
}
